import { c, classy, m } from '@onfido/castor';
import React from 'react';
import { withRef } from '../../utils';
export const Spinner = withRef(function Spinner({ size = 'medium', children, className, ...restProps }, ref) {
    return (React.createElement("div", { ...restProps, ref: ref, className: classy(c('spinner'), m(size), className) }, children));
});
//# sourceMappingURL=spinner.js.map